module.exports = __webpack_public_path__ + "fonts/SFUIText-HeavyItalic.2e0f8e18.ttf";